import { createRoot } from 'react-dom/client';
import CloseSlab from './CloseModal';
function Create(component) {
  CloseSlab();
  const div = document.createElement('div');
  createRoot(
    document.getElementById('modal-container').appendChild(div),
  ).render(component);
}

export default Create;
